import React, { useState } from "react";
import { ChevronDown, Info } from "lucide-react";
import { FRAGRANCE_DISCLAIMER } from "../mock";

const FragranceSelector = ({ fragrances, selected, onSelect }) => {
  const [open, setOpen] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  // Pick the currently-selected fragrance, otherwise the first in-stock one, otherwise the first.
  const active =
    fragrances.find((f) => f.code === selected) ||
    fragrances.find((f) => !(f.outOfStock || f.stock_status === "out_of_stock")) ||
    fragrances[0];

  return (
    <div className="border-t border-b border-off-white/10 py-6">
      <div className="flex items-center justify-between mb-3">
        <p className="font-mono text-[10px] tracking-[0.3em] text-rose">// FRAGRANCE</p>
        <button
          onClick={() => setShowDisclaimer(!showDisclaimer)}
          className="flex items-center gap-1 font-mono text-[9px] tracking-[0.25em] text-off-white/50 hover:text-rose transition-colors-only"
        >
          <Info size={12} />
          DISCLAIMER
        </button>
      </div>

      {showDisclaimer && (
        <p className="text-[11px] text-off-white/55 leading-relaxed mb-4 border border-off-white/10 p-3 bg-off-white/[0.02]">
          {FRAGRANCE_DISCLAIMER}
        </p>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between border border-off-white/20 hover:border-rose px-4 py-3 transition-colors-only text-left"
        data-testid="fragrance-toggle"
      >
        <div className="flex items-baseline gap-3">
          <span className="font-mono text-[11px] tracking-[0.2em] text-rose">{active.code}</span>
          <span className="text-off-white text-sm">{active.name}</span>
        </div>
        <ChevronDown size={16} className={`text-off-white/60 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      <p className="text-off-white/70 text-[13px] leading-relaxed mt-3 font-light">{active.notes}</p>

      {open && (
        <ul className="mt-3 max-h-[320px] overflow-y-auto border border-off-white/10">
          {fragrances.map((f) => {
            const isOut = !!f.outOfStock || f.stock_status === "out_of_stock";
            return (
              <li key={f.code}>
                <button
                  onClick={() => {
                    if (isOut) return;
                    onSelect(f.code);
                    setOpen(false);
                  }}
                  disabled={isOut}
                  aria-disabled={isOut}
                  className={`w-full text-left px-4 py-3 border-b border-off-white/5 transition-colors-only ${
                    isOut
                      ? "opacity-40 cursor-not-allowed"
                      : "hover:bg-rose/10"
                  } ${selected === f.code ? "bg-rose/10" : ""}`}
                  data-testid={`fragrance-option-${f.code}`}
                >
                  <div className="flex items-baseline gap-3">
                    <span className="font-mono text-[11px] tracking-[0.2em] text-rose">{f.code}</span>
                    <span className={`text-sm ${isOut ? "line-through text-off-white/60" : "text-off-white"}`}>
                      {f.name}
                    </span>
                    {isOut && (
                      <span className="ml-auto font-mono text-[9px] tracking-[0.25em] text-off-white/70 border border-off-white/25 px-2 py-0.5">
                        OUT OF STOCK
                      </span>
                    )}
                  </div>
                  <p className="text-off-white/55 text-[11px] leading-snug mt-1 line-clamp-2">{f.notes}</p>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default FragranceSelector;
